import VideoColumn from 'components/Video/VideoColumn';
import VideoSplit from 'components/Video/VideoSplit';

import type { VideoComponentProps } from 'components/Video/config';
import type { FeaturedTextStatsProps } from 'molecules/Stats';
import type { ComponentPropsWithoutRef, FC } from 'react';

type ComponentVideoProps = VideoComponentProps &
  Pick<FeaturedTextStatsProps, 'featuredStats'> &
  ComponentPropsWithoutRef<'section'>;

const ComponentVideo: FC<ComponentVideoProps> = props => {
  const generateVideoComponentProps = (type?: string) => {
    switch (type) {
      case 'contained':
      case 'full-width':
        return <VideoColumn {...props} />;
      case 'split':
        return <VideoSplit {...props} />;
      default:
        return null;
    }
  };

  return generateVideoComponentProps(props.variant);
};

export default ComponentVideo;
